<mat-checkbox color="primary" [(ngModel)]="allHours" (change)="toggleEnableBHR($event)">{{
  "ONSIP_I18N.AVAILABLE_247" | translate
}}</mat-checkbox>
<form [formGroup]="bhrForm">
  @if (bhrForm && bhrForm.value.enabled) {
  <div>
    <div>
      <mat-form-field class="bhr-timezone" appearance="outline">
        <mat-label>{{ "ONSIP_I18N.TIMEZONE" | translate }}</mat-label>
        <mat-select placeholder="Timezone" formControlName="timezone">
          @for (tz of timezoneOptions; track tz) {
          <mat-option [value]="tz.value">{{ tz.text }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @for (day of dayOptions; track day) {
    <div class="bhr-day">
      <span class="bhr-day-label">{{ dayOptionsTranslated[day] | titlecase }}</span>
      <form [formGroup]="bhrForm.controls[day]" class="bhr-day-form">
        <div class="bhr-day">
          <mat-form-field onsip-form-field-flush-outline class="bhr-time" appearance="outline">
            <mat-label>{{ "ONSIP_I18N.OPENING" | translate }}</mat-label>
            <onsip-bhr-time-input formControlName="start"></onsip-bhr-time-input>
            <!-- ALL MAT-ERRORS GO ON PARENT FORM -->
          </mat-form-field>
          <mat-form-field onsip-form-field-flush-outline class="bhr-time" appearance="outline">
            <mat-label>{{ "ONSIP_I18N.CLOSING" | translate }}</mat-label>
            <onsip-bhr-time-input formControlName="end"></onsip-bhr-time-input>
            <!-- ALL MAT-ERRORS GO ON PARENT FORM -->
          </mat-form-field>
          <mat-checkbox
            color="primary"
            formControlName="disabled"
            (change)="toggleDisableDay($event, day)"
            >{{ "ONSIP_I18N.CLOSED" | translate }}</mat-checkbox
          >
        </div>
        <mat-error>{{ getErrorMessage(bhrForm.controls[day]) }}</mat-error>
      </form>
    </div>
    }
  </div>
  }
</form>
